import { render, staticRenderFns } from "./Hip.vue?vue&type=template&id=37ce8659&scoped=true"
import script from "./Hip.vue?vue&type=script&lang=js"
export * from "./Hip.vue?vue&type=script&lang=js"
import style0 from "./Hip.vue?vue&type=style&index=0&id=37ce8659&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce8659",
  null
  
)

export default component.exports